var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#206BB1",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4601 28.1C18.6161 28.3737 18.8405 28.6009 19.1108 28.7588C19.3811 28.9168 19.6876 29 19.9997 29C20.3117 29 20.6183 28.9168 20.8885 28.7588C21.1588 28.6009 21.3832 28.3737 21.5393 28.1",
    stroke: "#206BB1",
    strokeWidth: 1.12501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7151 11.0081C18.3518 11.0818 17.0684 11.682 16.1291 12.6851C15.1898 13.6882 14.6662 15.0177 14.6661 16.4C14.6661 20.4491 13.4118 21.7604 12.2322 22.9934C12.1161 23.1223 12.0395 23.2825 12.0117 23.4547C11.9838 23.6268 12.006 23.8035 12.0755 23.9631C12.145 24.1227 12.2589 24.2584 12.4031 24.3537C12.5474 24.4491 12.716 24.4999 12.8883 24.5H27.1108C27.283 24.5001 27.4516 24.4495 27.596 24.3543C27.7404 24.2592 27.8543 24.1236 27.924 23.9641C27.9937 23.8046 28.0161 23.628 27.9885 23.4558C27.9609 23.2837 27.8845 23.1233 27.7686 22.9943C27.0361 22.2293 26.277 21.4364 25.8041 19.9811",
    stroke: "#206BB1",
    strokeWidth: 1.12501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3329 16.4C26.8056 16.4 27.9996 15.1911 27.9996 13.7C27.9996 12.2088 26.8056 11 25.3329 11C23.8601 11 22.6661 12.2088 22.6661 13.7C22.6661 15.1911 23.8601 16.4 25.3329 16.4Z",
    stroke: "#206BB1",
    strokeWidth: 1.12501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notificationicon.7b1732058e79cf2c7a5530dd22bc2a37.svg";
export { ForwardRef as ReactComponent };